define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CommissionRoleModel = /** @class */ (function () {
        function CommissionRoleModel(data) {
            this.Id = ko.observable(0);
            this.EmployeeId = ko.observable(0);
            this.Name = ko.observable();
            this.IsPrimary = ko.observable();
            this.Status = ko.observable();
            this.StatusName = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CommissionRoleModel.Mapping, self);
            }
        }
        CommissionRoleModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CommissionRoleModel(options.data);
            }
        };
        return CommissionRoleModel;
    }());
    return CommissionRoleModel;
});
//# sourceMappingURL=CommissionRoleModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CommissionRoleModel.js
// module id = 301
// module chunks = 2